import Nullstack from 'nullstack';
export default function IconChartRadar({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chart-radar",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 3l9.5 7l-3.5 11h-12l-3.5 -11z"
  }), "   ", Nullstack.element("path", {
    d: "M12 7.5l5.5 4l-2.5 5.5h-6.5l-2 -5.5z"
  }), "   ", Nullstack.element("path", {
    d: "M2.5 10l9.5 3l9.5 -3"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v10l6 8"
  }), "   ", Nullstack.element("path", {
    d: "M6 21l6 -8"
  }), " ");
}